export default __webpack_public_path__ + "static/media/3.ae87a29c.jpeg";